import inquirer from "inquirer"
import path from "node:path"

import { TemplateFramework } from "../../flow/types.js"
import { colorize } from "../../ui.js"

export async function promptTemplateDestination(input: {
  defaultDestinationPath?: string
  error: (message: string) => never
  framework: TemplateFramework
  log: (message: string) => void
}): Promise<string> {
  const cwd = process.cwd()
  const fallbackPath = path.resolve(cwd, `supernova-container-${input.framework.toLowerCase()}`)
  const suggestedPath = path.resolve(input.defaultDestinationPath ?? fallbackPath)
  const relativeSuggestedPath = path.relative(cwd, suggestedPath)
  const promptDefaultValue =
    relativeSuggestedPath && !relativeSuggestedPath.startsWith("..") && !path.isAbsolute(relativeSuggestedPath)
      ? relativeSuggestedPath
      : suggestedPath

  input.log("A new folder will be created at this location with the container template inside for further setup.")

  const response = await inquirer.prompt<{ templateDestinationPath: string }>([
    {
      default: promptDefaultValue,
      message: colorize("Where should we create the container?", "blue"),
      name: "templateDestinationPath",
      type: "input",
    },
  ])

  const rawTemplateDestinationPath = response.templateDestinationPath.trim()
  if (!rawTemplateDestinationPath) input.error("Template destination path is required.")

  return path.resolve(rawTemplateDestinationPath)
}
